/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";

import styles from "./styles.module.scss";
import Loading from "../../../home/components/Loading";

import IsValidEmail from "../../../../utils/validators/IsValidEmail";
import InputForm from "../../../../components/InputForm";
import FormActions from "../../components/FormActions";
import { AppAPIService } from "../../../../services/AppAPIService";
import Swal from "sweetalert2";
import store from "../../../../store/store";
import { Typography, Container, Grid } from "@material-ui/core";
import { LabelTitle } from "./components/LabelTitle";
import { UserRole } from "../../../../enums/UserRole";
import FormatDocument from "../../../../utils/FormatDocument";
import verifyCpfCnpj from "../../../../utils/validators/IsValidCpfCnpj";
import { USER_ROLES } from "../../../../enum/UserRoles";

const UserForm = () => {
  let api = AppAPIService.getInstance();
  const history = useHistory();
  const { auth } = store.getState();
  const [loading, setLoading] = useState(false);

  const [cpf, setCpf] = useState("");
  const [cpfRole, setCpfRole] = useState("ok");
  const [cpfError, setCpfError] = useState("");
  const handleInputCpf = (e) => {
    e = e.replace(/[.,-/]/g, "");
    if (e.length > 18) {
      return;
    }
    if (e.length < 1) {
      setCpf(e);
      setCpfError("CPF/CNPJ Obrigatório");
      setCpfRole("notOk");
    } else if (!verifyCpfCnpj(e).isValid) {
      setCpf(e);
      setCpfError("Não é um CPF/CNPJ válido.");
      setCpfRole("notOk");
    } else {
      setCpf(FormatDocument(e));
      setCpfError("");
      setCpfRole("ok");
    }
  };

  /*name*/
  const [name, setName] = useState("");
  const [nameRole, setNameRole] = useState("");
  const [nameError, setNameError] = useState("");
  const handleInputName = (name) => {
    if (!name) {
      setName();
      setNameError("Campo obrigatório");
      setNameRole("notOk");
    } else {
      setName(name);
      setNameError("");
      setNameRole("ok");
    }
  };
  /* end name*/

  /*email*/
  const [email, setEmail] = useState("");
  const [emailRole, setEmailRole] = useState("");
  const [emailError, setEmailError] = useState("");
  const handleInputEmail = useCallback((e) => {
    if (e.length < 1) {
      setEmail(e);
      setEmailError("Campo obrigatório");
      setEmailRole("notOk");
    } else if (!IsValidEmail(e)) {
      setEmail(e);
      setEmailError("Não é um E-mail válido.");
      setEmailRole("notOk");
    } else {
      setEmail(e);
      setEmailError("");
      setEmailRole("ok");
    }
  }, []);
  /* end email*/

  /* profile */
  const [profilesOptions] = useState( auth.user.role === USER_ROLES.ADMIN ?[
    { value: UserRole.ADMIN, label: "Administrador" },
    { value: UserRole.COLLABORATOR, label: "Colaborador" },
    { value: UserRole.CLIENT, label: "Cliente" },
  ]: [
    { value: UserRole.COLLABORATOR, label: "Colaborador" },
    { value: UserRole.CLIENT, label: "Cliente" },
  ]);

  const [profile, setProfile] = useState("");
  const [profileRole, setProfileRole] = useState("ok");
  const [profileError, setProfileError] = useState("");
  const handleInputProfile = useCallback((e) => {
    if (!e) {
      setProfileError("Campo obrigatório");
      setProfileRole("notOk");
      setProfile("")
    } else {
      setProfile(e);
      setProfileError("");
      setProfileRole("ok");
    }
  }, []);
  /* end profile */

  //// callbacks
  /* end cep change */
  /* clean form */
  const onCleanForm = async () => {
    setName("");
    setEmail("");
    setProfile("");
    setCpf("");
  };

  /* form validation */
  const formIsValid = useCallback(() => {
    let validForm = true;

    validForm =
      name !== "" &&
      nameRole === "ok" &&
      email !== "" &&
      IsValidEmail(email) &&
      emailRole === "ok" &&
      profile !== "" &&
      cpfRole === "ok" &&
      cpf !== "" &&
      verifyCpfCnpj(cpf).isValid &&
      profileRole === "ok";
    return validForm;
  }, [name, nameRole, email, emailRole, profile, profileRole, cpf, cpfRole]);

  /* end form validation */
  /* submit */
  const submit = useCallback(
    async (e) => {
      setLoading(true);
      e.preventDefault();
      try {
        setLoading(true);
        const createdUser = await api.makeHttpRequest({
          url: `/user`,
          method: "POST",
          data: {
            id: "",
            username: name,
            cpfCnpj: cpf.replace(/[^0-9]/g, ""),
            email,
            role: profile.value,
          },
        });
        setLoading(false);
        const invitationAccepted =
          createdUser?.invitationDelivery?.accepted === true;
        Swal.fire({
          icon: invitationAccepted ? "success" : "warning",
          title: invitationAccepted ? "Sucesso!" : "Usuário criado",
          text: invitationAccepted
            ? "Usuário criado com sucesso. Um e-mail para finalização de cadastro foi enviado para: " + email
            : "O usuário foi criado, mas o provedor não confirmou o envio do convite. Reenvie o convite pela tela de usuários.",
        }).then(() => {
          history.push("/admin/usuario");
        });
      } catch (error) {
        setLoading(false);
        let message = "";
        if (error?.response?.status === 409) {
          message = ", Usuário já cadastrado.";
        }
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Erro ao criar usuário " + message + ".",
        });
        setCpfError("CPF/CNPJ já cadastrado.");
        setCpfRole("notOk");
        setCpf("");
      } finally {
        setLoading(false);
      }
    },
    [name,
      email,
      profile,
      history,
      cpf,
      api,
      auth.token,
      auth.user,
      auth,
    ]
  );
  /* end submit */

  /* end clean form */
  return (
    <div className={styles.container}
    >
      <Loading isLoading={loading} />
      <form className={styles.form}
        style={{
          marginTop: "24px"
        }}
        autoComplete="off">
        <Container
          maxWidth="xxl"
          style={{
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            padding: 0,
            margin: 0,
          }}
        >
          <LabelTitle>
            <Typography
              variant="p"
              style={{
                fontSize: "18px",
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: "bold",
              }}
            >Dados Cadastrais</Typography>
          </LabelTitle>
        </Container>
        <div className={styles.containerInputs}>

          <Grid container>
            <Grid sm={6}
              style={{
                padding: "0 10px 0 0"
              }}
            >
              <InputForm
                type="text"
                name="name"
                placeholder="Digite a razão social ou nome completo"
                label={"Razão Social/Nome *"}
                value={name}
                required={true}
                onChange={handleInputName}
                error={nameError}
                role={nameRole}
              />
            </Grid>
            <Grid sm={6}>
              <InputForm
                type="email"
                name="email"
                placeholder="Digite o e-mail"
                label={"E-mail *"}
                value={email}
                error={emailError}
                required={true}
                onChange={handleInputEmail}
                role={emailRole}
              />
            </Grid>
          </Grid>
        </div>

        <div className={styles.containerInputs}>
          <Grid container>
            <Grid sm={6}
                style={{
                  padding: "0 10px 0 0"
                }}
              >
                <InputForm
                  type="text"
                  name="cpf"
                  placeholder="Digite o CPF ou CNPJ"
                  label={"CPF/CNPJ *"}
                  value={cpf}
                  error={cpfError}
                  onChange={handleInputCpf}
                  role={cpfRole}
                  required
                />
            </Grid>
            <Grid sm={6} >
              <InputForm
                type="text"
                name="profile"
                placeholder="Selecione o Perfil"
                label={"Perfil *"}
                isSelect={true}
                options={profilesOptions}
                value={profile}
                required={true}
                error={profileError}
                onChange={handleInputProfile}
                role={profileRole}
              />
            </Grid>
          </Grid>

        </div>
        <FormActions
          module={"usuario"}
          formIsValid={formIsValid()}
          onCleanForm={onCleanForm}
          onSubmit={submit}
          hideCancel={true}
          messagem
        />
      </form >
    </div >
  );
};
export default UserForm;
